<template>
	<div class="quick-actions">
		<button
				class="action-btn reboot"
				@click="isRebooting ? debouncedEmit('cancel-reboot') : debouncedEmit('start-reboot')"
				:disabled="disabled"
				:style="{ background: isRebooting ? 'var(--color-error-2)' : 'var(--color-surface-2)' }"
		>
			<div class="reboot-loader">
				<Icon v-if="!isRebooting" name="power" size="md"/>
				<Icon v-else name="loading" size="md"/>
				<span class="mono" v-if="rebootCount > 0">{{ String(rebootCount).padStart(2, '0') }}</span>
			</div>
			<span>{{ isRebooting ? 'Cancel' : 'Reboot' }}</span>
		</button>
		<button
				class="action-btn home"
				:class="{ 'is-home': isHome }"
				@click="debouncedEmit('command', 'return_home')"
				:disabled="disabled || spamLocked || isHome"
		>
			<Icon name="home" size="md"/>
			<span>Home</span>
		</button>
		<button
				class="action-btn"
				@click="debouncedEmit('command', 'toggle_menu')"
				:disabled="disabled || spamLocked"
		>
			<Icon name="hamburger" size="md"/>
			<span>Menu</span>
		</button>
	</div>
</template>

<script setup>
import {ref} from 'vue'
import Icon from './Icon.vue'

const DEBOUNCE_MS = 600
const lastClickTime = ref(0)

defineProps({
	disabled: {type: Boolean, default: false},
	spamLocked: {type: Boolean, default: false},
	isRebooting: {type: Boolean, default: false},
	rebootCount: {type: Number, default: 0},
	isHome: {type: Boolean, default: false},
})

const emit = defineEmits(['command', 'start-reboot', 'cancel-reboot'])

function debouncedEmit(event, ...args) {
	const now = Date.now()
	if (now - lastClickTime.value < DEBOUNCE_MS) return
	lastClickTime.value = now
	emit(event, ...args)
}
</script>

<style scoped>
.quick-actions {
	display: grid;
	/*grid-template-columns: repeat(3, 1fr);*/
	grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));
	gap: var(--spacing-md);
}

.action-btn {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--spacing-xs);
	padding: var(--spacing-lg);
	background: var(--color-surface-2);
	color: var(--color-text);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-md);
	cursor: pointer;
	transition: all var(--transition-fast);
}

.action-btn:disabled {
	opacity: 0.5;
	filter: brightness(0.6);
	cursor: not-allowed;
}

.reboot-loader {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: var(--spacing-sm);
}

.action-btn.is-home {
	box-shadow: 0 0 var(--spacing-xl) var(--color-primary) inset;
}

.action-btn.is-home:disabled {
	opacity: 1;
	filter: none;
}
</style>